import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CupraOperationModel } from '../../../../models/cupraoperation';
import { CupraCalculatorConfigurationOperationHtmlService } from '../../../../services/cupracalculator-configuration-operation-html.service';

@Component({
  templateUrl: './operation-modal.component.html',
  styleUrls: ['./operation-modal.component.scss']
})

export class OperationModalComponent implements OnInit {

  @Input() operation: CupraOperationModel;
  htmlInfo: SafeHtml;
  
  constructor(public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private service: CupraCalculatorConfigurationOperationHtmlService) { }

  ngOnInit() {    
    this.getHtml();
  }

  getHtml() {
    this.service.getFiles(this.operation.IdHtml).subscribe((file) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => {
        this.htmlInfo = this.sanitizer.bypassSecurityTrustHtml(fileReader.result.toString());
      }
      fileReader.readAsText(file);
    });
  }

  includeOperation() {
    this.activeModal.close(this.operation);
  }


}
